import React, { useState, useRef, useEffect } from "react";
import {
  IoEyeOutline,
  IoChevronBackOutline,
  IoChevronForwardOutline,
} from "react-icons/io5";
import "./pages.css";
import jazz from "../../assets/jazz.jpg";
import bluss from "../../assets/bluss.jfif";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../../utilis/api";

// live
const VIP_PRICE_ID = "price_1TLq0dIdDYF1KaufyVPlUhHa";
// local
// const VIP_PRICE_ID = "price_1TMBML16booVXHu6mWO5XSxx";
const recommendedCourses = [
  {
    id: 1,
    title: "Advanced Jazz Improvisation",
    description:
      "Master advanced jazz improvisation techniques including chord substitutions, modal scales, and phrasing.",
    teacher: "Anya K.",
    deadline: "2026-07-01",
    image: jazz,
    lessons: ["Lesson 1: Modes", "Lesson 2: Chords", "Lesson 3: Soloing"],
  },
  {
    id: 2,
    title: "Blues Guitar Soloing",
    description:
      "Learn modern blues guitar soloing with phrasing, licks, and tone tips.",
    teacher: "John D.",
    deadline: "2026-08-01",
    image: bluss,
    lessons: ["Lesson 1: Bending", "Lesson 2: Vibrato", "Lesson 3: Licks"],
  },
  {
    id: 3,
    title: "Pop Piano Techniques",
    description:
      "Learn modern pop piano playing techniques with rhythm, chords, and song arrangements.",
    teacher: "Emma R.",
    deadline: "2026-09-01",
    image: jazz,
    lessons: ["Lesson 1: Chords", "Lesson 2: Song Structure"],
  },
  {
    id: 4,
    title: "Rock Guitar Essentials",
    description:
      "Master rock guitar essentials including riffs, solos, and power chords.",
    teacher: "Jack H.",
    deadline: "2026-10-01",
    image: bluss,
    lessons: ["Lesson 1: Power Chords", "Lesson 2: Solos"],
  },
  {
    id: 5,
    title: "Jazz Theory Deep Dive",
    description: "Deep dive into jazz theory and advanced harmony concepts.",
    teacher: "Anya K.",
    deadline: "2026-11-01",
    image: jazz,
    lessons: ["Lesson 1: Modes", "Lesson 2: Chords"],
  },
];

const Subscription = () => {
  const [modalCourse, setModalCourse] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loadingSub, setLoadingSub] = useState(true);
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);

  const scrollLeft = () =>
    sliderRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  const scrollRight = () =>
    sliderRef.current?.scrollBy({ left: 300, behavior: "smooth" });

  // Fetch subscription — with Authorization header
  useEffect(() => {
    const fetchSubscription = async () => {
      if (!token) {
        setLoadingSub(false);
        return;
      }
      try {
        const res = await api.get("/payments/my-subscription", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = res.data;

        console.log("Subscription data:", data);
        setSubscription(data);
      } catch (err) {
        console.error("Failed to fetch subscription:", err);
      } finally {
        setLoadingSub(false);
      }
    };
    fetchSubscription();
  }, [token]);

  // Upgrade to VIP — with Authorization header
  const handleUpgrade = async () => {
    if (!token) {
      navigate("/");
      return;
    }
    setUpgradeLoading(true);
    try {
      const res = await api.post(
        "/payments/create-checkout-session",
        {
          priceId: VIP_PRICE_ID,
          planType: "yearly",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = res.data;

      if (data.url) {
        window.location.href = data.url;
      } else {
        alert(`Error: ${data.message || "No checkout URL received"}`);
      }
    } catch (err) {
      alert(
        err.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    } finally {
      setUpgradeLoading(false);
    }
  };

  const daysLeft = subscription?.expiryDate
    ? Math.max(
        0,
        Math.ceil(
          (new Date(subscription.expiryDate) - new Date()) /
            (1000 * 60 * 60 * 24),
        ),
      )
    : 0;
  console.log(subscription?.expiryDate);
  const totalDays = subscription?.purchasedAt
    ? Math.ceil(
        (new Date(subscription.expiryDate) -
          new Date(subscription.purchasedAt)) /
          (1000 * 60 * 60 * 24),
      )
    : subscription?.planType === "monthly"
      ? 30
      : 30;
  const progressPercent = Math.min(
    100,
    Math.round(((totalDays - daysLeft) / totalDays) * 100),
  );
  const renderActionButton = () => {
    if (!subscription?.hasSubscription || subscription?.status === "Expired") {
      return (
        <button
          className="dashboard-btn register-btn"
          onClick={() => navigate("/membership")}
        >
          {subscription?.status === "Expired" ? "Renew Plan" : "Buy a Plan"}
        </button>
      );
    }
    if (subscription?.price === 39 && subscription?.status === "Active") {
      return (
        <button
          className="dashboard-btn register-btn"
          onClick={handleUpgrade}
          disabled={upgradeLoading}
          style={{
            background: "linear-gradient(to right, #e6be5d, #f59e0b)",
            color: "#000",
            fontWeight: 700,
          }}
        >
          {upgradeLoading ? "Redirecting..." : "⬆ Upgrade to VIP"}
        </button>
      );
    }
    if (subscription?.price === 39 && subscription?.status === "Active") {
      return (
        <button className="dashboard-btn" disabled>
          👑 VIP Active ✓
        </button>
      );
    }
  };

  return (
    <>
      <div className="overview-container">
        <h2>My Subscription</h2>

        {loadingSub ? (
          <p style={{ color: "#888" }}>Loading subscription...</p>
        ) : (
          <>
            {/* No Subscription */}
            {!subscription?.hasSubscription && (
              <div
                style={{
                  textAlign: "center",
                  padding: "3rem 2rem",
                  background: "linear-gradient(135deg, #111, #1a1a1a)",
                  borderRadius: "16px",
                  border: "1px solid #333",
                  marginBottom: "1.5rem",
                }}
              >
                <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🎵</div>
                <h3 style={{ color: "#fff", marginBottom: "0.5rem" }}>
                  No Active Plan
                </h3>
                <p style={{ color: "#9ca3af", marginBottom: "1.5rem" }}>
                  Subscribe to unlock exclusive benefits, discounts, and more!
                </p>
                <button
                  className="dashboard-btn register-btn"
                  onClick={() => navigate("/membership")}
                  style={{ padding: "12px 32px", fontSize: "15px" }}
                >
                  View Plans →
                </button>
              </div>
            )}

            {/* Active Plan Card */}
            {subscription?.hasSubscription &&
              subscription?.status === "Active" && (
                <div
                  style={{
                    background:
                      subscription.price === 39
                        ? "linear-gradient(135deg, #1a0f00, #2a1800)"
                        : "linear-gradient(135deg, #0a0a1a, #1a1a2a)",
                    border:
                      subscription.price === 39
                        ? "1.5px solid #e6be5d"
                        : "1.5px solid #6366f1",
                    borderRadius: "16px",
                    padding: "1.8rem",
                    marginBottom: "1.5rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      flexWrap: "wrap",
                      gap: "1rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <div>
                      {subscription.price === 39 && (
                        <span
                          style={{
                            background: "#e6be5d",
                            color: "#000",
                            fontSize: "11px",
                            fontWeight: 700,
                            padding: "3px 10px",
                            borderRadius: "20px",
                            marginBottom: "8px",
                            display: "inline-block",
                            letterSpacing: "0.05em",
                          }}
                        >
                          👑 VIP MEMBER
                        </span>
                      )}
                      <h3
                        style={{
                          color: "#fff",
                          fontSize: "1.5rem",
                          margin: "4px 0",
                        }}
                      >
                        {subscription.price === 39
                          ? "Base Subscription"
                          : "VIP Subscription"}
                      </h3>
                      <p
                        style={{
                          color: "#9ca3af",
                          fontSize: "14px",
                          margin: 0,
                        }}
                      >
                        {subscription.planType === 39
                          ? "$39 / month"
                          : "$79.99 / month"}
                      </p>
                    </div>

                    <div style={{ textAlign: "right" }}>
                      <span
                        style={{
                          background: "#14532d",
                          color: "#22c55e",
                          padding: "5px 14px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: 600,
                          display: "block",
                          marginBottom: "8px",
                        }}
                      >
                        ● Active
                      </span>
                      <p
                        style={{
                          color: "#e6be5d",
                          fontSize: "13px",
                          fontWeight: 600,
                          margin: 0,
                        }}
                      >
                        {daysLeft} days left
                      </p>
                      <p
                        style={{
                          color: "#9ca3af",
                          fontSize: "12px",
                          margin: "2px 0 0",
                        }}
                      >
                        Expires:{" "}
                        {new Date(subscription.expiryDate).toLocaleDateString(
                          "en-US",
                          {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          },
                        )}
                      </p>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div style={{ marginBottom: "0.5rem" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "12px",
                        color: "#9ca3af",
                        marginBottom: "6px",
                      }}
                    >
                      <span>Plan Usage</span>
                      <span>{progressPercent}% used</span>
                    </div>
                    <div
                      style={{
                        background: "#333",
                        borderRadius: "10px",
                        height: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: `${progressPercent}%`,
                          height: "100%",
                          background:
                            subscription.planType === "monthly"
                              ? "linear-gradient(to right, #e6be5d, #f59e0b)"
                              : "linear-gradient(to right, #6366f1, #818cf8)",
                          borderRadius: "10px",
                          transition: "width 0.5s ease",
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}

            {/* Upgrade Banner — only for monthly active users */}
            {subscription?.price === 39 &&
              subscription?.status === "Active" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #1a1200, #2a1f00)",
                    border: "1.5px solid #e6be5d",
                    borderRadius: "16px",
                    padding: "1.5rem",
                    marginBottom: "1.5rem",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "-30px",
                      right: "-30px",
                      width: "120px",
                      height: "120px",
                      background:
                        "radial-gradient(circle, rgba(230,190,93,0.15), transparent)",
                      borderRadius: "50%",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "1rem",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        <span style={{ fontSize: "1.3rem" }}>👑</span>
                        <h4
                          style={{
                            color: "#e6be5d",
                            margin: 0,
                            fontSize: "1.1rem",
                          }}
                        >
                          Upgrade to VIP — Save More!
                        </h4>
                      </div>
                      <p
                        style={{
                          color: "#d1d5db",
                          fontSize: "13px",
                          margin: "0 0 12px",
                        }}
                      >
                        You're on the Base Plan. Upgrade to VIP and unlock:
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        {[
                          "20% off lessons",
                          "Unlimited replays",
                          "35% off concerts",
                          "Honorary member",
                          "Early access drops",
                        ].map((benefit, i) => (
                          <span
                            key={i}
                            style={{
                              background: "rgba(230,190,93,0.1)",
                              border: "1px solid rgba(230,190,93,0.3)",
                              color: "#e6be5d",
                              fontSize: "11px",
                              padding: "3px 10px",
                              borderRadius: "20px",
                            }}
                          >
                            ✓ {benefit}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div style={{ textAlign: "center", minWidth: "160px" }}>
                      <p
                        style={{
                          color: "#9ca3af",
                          fontSize: "12px",
                          margin: "0 0 4px",
                        }}
                      >
                        Only
                      </p>
                      <p
                        style={{
                          color: "#e6be5d",
                          fontSize: "2rem",
                          fontWeight: 700,
                          margin: "0 0 2px",
                        }}
                      >
                        $79.99
                      </p>
                      <p
                        style={{
                          color: "#9ca3af",
                          fontSize: "12px",
                          margin: "0 0 12px",
                        }}
                      >
                        per month (~$6.67/mo)
                      </p>
                      <button
                        className="dashboard-btn register-btn"
                        onClick={handleUpgrade}
                        disabled={upgradeLoading}
                        style={{
                          background:
                            "linear-gradient(to right, #e6be5d, #f59e0b)",
                          color: "#000",
                          fontWeight: 700,
                          width: "100%",
                          padding: "10px",
                          fontSize: "14px",
                        }}
                      >
                        {upgradeLoading ? "Redirecting..." : "⬆ Upgrade Now"}
                      </button>
                    </div>
                  </div>
                </div>
              )}

            {/* Expired Banner */}
            {subscription?.status === "Expired" && (
              <div
                style={{
                  background: "#1a0000",
                  border: "1.5px solid #ef4444",
                  borderRadius: "16px",
                  padding: "1.2rem 1.5rem",
                  marginBottom: "1.5rem",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "1rem",
                }}
              >
                <div>
                  <h4 style={{ color: "#ef4444", margin: "0 0 4px" }}>
                    ⚠ Subscription Expired
                  </h4>
                  <p style={{ color: "#9ca3af", fontSize: "13px", margin: 0 }}>
                    Renew your plan to continue enjoying all benefits.
                  </p>
                </div>
                <button
                  className="dashboard-btn register-btn"
                  onClick={() => navigate("/membership")}
                >
                  Renew Now
                </button>
              </div>
            )}

            {/* Table */}
            {subscription?.hasSubscription && (
              <table className="lessons-table">
                <thead>
                  <tr>
                    <th>Plan</th>
                    <th>Purchased</th>
                    <th>Expiry</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {subscription.price === 39
                        ? "Base — $39/mo"
                        : "VIP — $79.99/mo"}
                    </td>
                    <td>
                      {subscription?.purchasedAt
                        ? new Date(
                            subscription.purchasedAt,
                          ).toLocaleDateString()
                        : "—"}
                    </td>
                    <td>
                      {subscription?.expiryDate
                        ? new Date(subscription.expiryDate).toLocaleDateString()
                        : "—"}
                    </td>
                    <td
                      style={{
                        color:
                          subscription?.status === "Active"
                            ? "#22c55e"
                            : "#ef4444",
                        fontWeight: 500,
                      }}
                    >
                      {subscription?.status}
                    </td>
                    <td>{renderActionButton()}</td>
                  </tr>
                </tbody>
              </table>
            )}
          </>
        )}
      </div>

      {/* Slider */}
      {/* <section className="recommended-section">
        <h2>Recommended Courses</h2>
        <div className="slider-wrapper">
          <button className="slider-arrow left" onClick={scrollLeft}>
            <IoChevronBackOutline size={24} />
          </button>
          <div className="slider" ref={sliderRef}>
            {recommendedCourses.map((course) => (
              <div key={course.id} className="card slider-card">
                <div style={{ position: "relative" }}>
                  <img
                    src={course.image}
                    alt={course.title}
                    className="course-thumbnail"
                  />
                  <button
                    className="eye-btn"
                    onClick={() => setModalCourse(course)}
                  >
                    <IoEyeOutline size={20} />
                  </button>
                </div>
                <h3 className="course-title">{course.title}</h3>
                <p style={{ fontSize: "0.85rem", color: "#4b5563" }}>
                  {course.description.split(" ").slice(0, 20).join(" ")}...
                </p>
                <button
                  className="dashboard-btn register-btn"
                  onClick={() => navigate("/membership")}
                >
                  Subscribe
                </button>
              </div>
            ))}
          </div>
          <button className="slider-arrow right" onClick={scrollRight}>
            <IoChevronForwardOutline size={24} />
          </button>
        </div>
      </section> */}

      {/* Modal */}
      {/* {modalCourse && (
        <div className="modal-overlay" onClick={() => setModalCourse(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{modalCourse.title}</h2>
            <img
              src={modalCourse.image}
              alt={modalCourse.title}
              style={{ width: "100%", borderRadius: "12px", margin: "1rem 0" }}
            />
            <p>{modalCourse.description}</p>
            <p>Teacher: {modalCourse.teacher}</p>
            <p>Deadline: {modalCourse.deadline}</p>
            <h4>Lessons:</h4>
            <ul className="activities-list">
              {modalCourse.lessons.map((lesson, i) => (
                <li key={i}>{lesson}</li>
              ))}
            </ul>
            <button
              className="dashboard-btn register-btn"
              style={{ marginTop: "1rem" }}
              onClick={() => navigate("/membership")}
            >
              Subscribe
            </button>
            <button
              className="dashboard-btn"
              style={{
                marginTop: "0.5rem",
                marginLeft: "1rem",
                background: "#9ca3af",
              }}
              onClick={() => setModalCourse(null)}
            >
              Close
            </button>
          </div>
        </div>
      )} */}
    </>
  );
};

export default Subscription;
